import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import axios from 'src/app/Service/axios';
import moment from 'moment-jalaali';
declare let $: any;

@Component({
  selector: 'app-report-modal',
  templateUrl: './report-modal.component.html',
  styleUrls: ['./report-modal.component.css']
})

export class ReportModalComponent {
  @Input() car: any;
  @Input() acssess: any;
  @Input() carId: number = 0;

  @Output() apiChange = new EventEmitter<string>();
  @Output() vehicleDashboardRequested = new EventEmitter<void>();
  @Output() tankerMoodChange = new EventEmitter<boolean>();
  @Output() tankerRouteChange = new EventEmitter<boolean>();

  bAllOperations = false;
  bReportOperations = false;
  bFinancialOperations = false;
  bTankerOperations = false;
  bSalary = false;
  bFuelSensor = false;
  bWeightSensor = false;
  bTemperatureSensor = false;
  bFlowmeter = false;

  reportOp_Title = 'لیست گزارش ها';
  api = '';
  bTankerMood = false;
  bTankerRoute = false;
  deviceEvents: any;

  mdl_Consumption: FormGroup;

  constructor(
    private router: Router,
    private gurdService: GurdServiceService,
    private fb: FormBuilder
  ) {
    this.mdl_Consumption = this.fb.group({
      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
      strUnitID: '',
      strSDate: '',
      strEDate: '',
    });

  }

  ngOnChanges(): void {
    if (this.carId) {
      this.mdl_Consumption.patchValue({ strUnitID: this.carId });
    }
  }

  open(): void {
    this.selectOperation('bReportOperations');
    $('#reportModal').modal('show');
  }

  hide(): void {
    $('#reportModal').modal('hide');
  }

  changeApi = async (txt: any) => {
    this.api = txt;
    this.apiChange.emit(txt);
    if (txt == 7 && !this.deviceEvents) {
      const resp = await axios.post(`GetDeviceEventsType`, {});
      this.deviceEvents = JSON.parse(resp.data);
    }
  };

  private setTankerMood(v: boolean): void {
    this.bTankerMood = v;
    this.tankerMoodChange.emit(v);
  }

  private setTankerRoute(v: boolean): void {
    this.bTankerRoute = v;
    this.tankerRouteChange.emit(v);
  }

  // called from template with extra flag
  onTankerRouteClick(): void {
    this.setTankerRoute(true);
  }

  onTankerMoodClick(api: string): void {
    this.changeApi(api);
    this.setTankerMood(true);
  }

  salary(): void {
    this.hide();
    this.router.navigate([`report/${this.carId}/14`]);
  }

  salaryBaseZone(): void {
    this.hide();
    this.router.navigate([`report/${this.carId}/16`]);
  }

  sourceDestEarning(type?: number): void {
    this.hide();
    if (type) window.open(`report/${this.carId}/${type}`, '_blank');
    else this.router.navigate([`report/${this.carId}/17`]);
  }

  inspectionReport(type: string = '18'): void {
    this.hide();
    window.open(`report/${this.carId}/${type}`, 'blank');
  }

  showAyab_Zahab(number: number): void {
    this.hide();
    this.router.navigateByUrl(`/ayab-zahab/${this.carId}/${number}`);
  }

  selectOperation(target: string): void {
    if (target == 'bAllOperations') {
      this.bFuelSensor = false;
      this.bReportOperations = false;
      this.bFinancialOperations = false;
      this.bTankerOperations = false;
      this.bSalary = false;
      this.bTemperatureSensor = false;
      this.bWeightSensor = false;
      this.bFlowmeter = false;
      this.reportOp_Title = 'لیست گزارش ها';
      this.bAllOperations = true;
    }
    if (target == 'bReportOperations') {
      this.bFuelSensor = false;
      this.bAllOperations = false;
      this.bFinancialOperations = false;
      this.bTankerOperations = false;
      this.bTemperatureSensor = false;
      this.bSalary = false;
      this.bFlowmeter = false;
      this.reportOp_Title = 'گزارش های عملیاتی';
      this.bReportOperations = true;
    }
    if (target == 'bFinancialOperations') {
      this.bAllOperations = false;
      this.bReportOperations = false;
      this.bTankerOperations = false;
      this.bSalary = false;
      this.bFuelSensor = false;
      this.bTemperatureSensor = false;
      this.bWeightSensor = false;
      this.bFlowmeter = false;
      this.reportOp_Title = 'گزارش های مالی و محدوده‌ای';
      this.bFinancialOperations = true;
    }
    if (target == 'bTankerOperations') {
      this.bAllOperations = false;
      this.bReportOperations = false;
      this.bFinancialOperations = false;
      this.bSalary = false;
      this.bFuelSensor = false;
      this.bTemperatureSensor = false;
      this.bWeightSensor = false;
      this.bFlowmeter = false;
      this.reportOp_Title = 'گزارش های تانکر';
      this.bTankerOperations = true;
    }
    if (target == 'bSalary') {
      this.bAllOperations = false;
      this.bReportOperations = false;
      this.bFinancialOperations = false;
      this.bTankerOperations = false;
      this.bFuelSensor = false;
      this.bWeightSensor = false;
      this.bTemperatureSensor = false;
      this.bFlowmeter = false;
      this.bSalary = true;
      this.reportOp_Title = 'گزارش ایاب ذهاب';
    }
    if (target == 'bFuelSensor') {
      this.bAllOperations = false;
      this.bReportOperations = false;
      this.bFinancialOperations = false;
      this.bTankerOperations = false;
      this.bSalary = false;
      this.bWeightSensor = false;
      this.bTemperatureSensor = false;
      this.bFlowmeter = false;
      this.bFuelSensor = true;
      this.reportOp_Title = 'گزارش های سوخت';
      this.mdl_Consumption.patchValue({
        strSDate: moment().format('jYYYY/jMM/01'),
        strEDate: moment().format('jYYYY/jMM/jDD'),
      });
    }
    if (target == 'bWeightSensor') {
      this.bAllOperations = false;
      this.bReportOperations = false;
      this.bFinancialOperations = false;
      this.bTankerOperations = false;
      this.bSalary = false;
      this.bFuelSensor = false;
      this.bTemperatureSensor = false;
      this.bFlowmeter = false;
      this.bWeightSensor = true;
      this.reportOp_Title = 'گزارش های وزن';
    }
    if (target == 'bTemperatureSensor') {
      this.bAllOperations = false;
      this.bReportOperations = false;
      this.bFinancialOperations = false;
      this.bTankerOperations = false;
      this.bSalary = false;
      this.bFuelSensor = false;
      this.bWeightSensor = false;
      this.bFlowmeter = false;
      this.bTemperatureSensor = true;
      this.reportOp_Title = 'گزارش های دما';
    }
    if (target == 'bFlowmeter') {
      this.bAllOperations = false;
      this.bReportOperations = false;
      this.bFinancialOperations = false;
      this.bTankerOperations = false;
      this.bSalary = false;
      this.bFuelSensor = false;
      this.bWeightSensor = false;
      this.bTemperatureSensor = false;
      this.bFlowmeter = true;
      this.reportOp_Title = 'پایش فلومتر';
    }
  }
}
